import { useContext } from 'react';
import { context } from '../data-providers/model';

export default () => useContext(context);
